// NProgress config
import NProgress from "nprogress";
export {NProgress};
